/**
 * Enum for events published by Typeahead
 */
export const EventDictionary = Object.freeze({
  SUGGESTIONS_MENU_OPEN_CLOSE_EVENT: { name: 'suggestions-menu-open-close' }
});

export const isTypeaheadEvent = (eventName) => {
  return Object.values(EventDictionary).some((eventKey) => eventKey.name === eventName);
};